// extracted by mini-css-extract-plugin
export default {"container":"TableHeader_container__5G2KT","add":"TableHeader_add__VMjVo"};